import { CSSProperties } from 'react'
import styled from 'styled-components'

type Props = {
  style?: CSSProperties
}

const Outer = styled.div<Props>`
  font-size: 14px;
  text-align: center;
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};

  a {
    color: ${({ theme }) => theme?.['-ds-core-400']?.value};
  }
`

const Terms = ({ style }: Props) => (
  <Outer style={style}>
    By signing up, you confirm that you accept the{' '}
    <a href="/terms" target="_blank" rel="noopener noreferrer">
      Terms of Service
    </a>{' '}
    and{' '}
    <a href="/privacy" target="_blank" rel="noopener noreferrer">
      Privacy Policy
    </a>
    .
  </Outer>
)

export default Terms
